import _ from "lodash";
/**--external-- */
import React, { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

/**--internal-- */
import LinkWithTooltip from "UIComponents/LinkWithTooltip";

/**--relative-- */
import classes from "./EvidenceFeedHeader.scss";
import { tooltipContainerStyle } from "./EvidenceFeedHeaderStyles";

const MAX_VISIBLE_MORE_FILTERS = 4;

const MAX_VISIBLE_FILTERS = 2;

const EvidenceFeedHeader = memo(props => {
  const {
    count,
    totalCount,
    t,
    label,
    selectedFiltersItems,
    evidenceFeedCountStyle,
  } = props;

  const renderFeedHeaderWithTooltip = () => {
    const displayItems =
      _.size(selectedFiltersItems) <= MAX_VISIBLE_MORE_FILTERS
        ? selectedFiltersItems
        : [..._.slice(selectedFiltersItems, 0, MAX_VISIBLE_MORE_FILTERS)];

    const moreSelectedFiltersCount =
      _.size(selectedFiltersItems) - MAX_VISIBLE_MORE_FILTERS;

    return (
      <LinkWithTooltip
        tooltip={
          <div>
            {_.map(displayItems, label => (
              <div key={label}>{label}</div>
            ))}
            {_.size(selectedFiltersItems) > MAX_VISIBLE_MORE_FILTERS && (
              <div className={classes.showMoreText}>{`+${t(
                "common:more_withNumber_andLabel",
                {
                  number: moreSelectedFiltersCount,
                  label: t("snp:filter", { count: moreSelectedFiltersCount }),
                }
              )}`}</div>
            )}
          </div>
        }
        tooltipContainerStyle={tooltipContainerStyle}
        placement={"bottom"}
      >
        <div className={classes.filterCountText}>
          {t("snp:for_label", {
            label: t("common:lowercase", {
              text: t("snp:selected_filter", {
                count: _.size(selectedFiltersItems),
              }),
            }),
          })}
        </div>
      </LinkWithTooltip>
    );
  };

  const renderFilters = () => {
    switch (_.size(selectedFiltersItems)) {
      case 0: {
        return null;
      }
      case 1:
      case MAX_VISIBLE_FILTERS: {
        return selectedFiltersItems[0];
      }
      default: {
        return renderFeedHeaderWithTooltip();
      }
    }
  };

  const evidenceFeedCountClasses = classNames(
    classes.evidenceFeedCount,
    "text-label"
  );

  const finalCount = !_.isUndefined(totalCount) ? totalCount : count;

  return (
    <div className={evidenceFeedCountClasses} style={evidenceFeedCountStyle}>
      {t(label)} {finalCount ? <>({finalCount})</> : null} {renderFilters()}
    </div>
  );
});

EvidenceFeedHeader.displayName = "EvidenceCountHeader";

EvidenceFeedHeader.defaultProps = {
  evidenceFeedCountStyle: {},
  selectedFiltersItems: [],
};

EvidenceFeedHeader.propTypes = {
  evidenceFeedCountStyle: PropTypes.object,
  selectedFiltersItems: PropTypes.array,
};

export default EvidenceFeedHeader;
